import { Saih } from "./../types/saih.type";
import { responseHandlerDefault } from "./../utils/handler.util";
import { Filter } from "./../types/filter.type";
import axios from "./api";
import { Pagination } from "./../types/pagination.type";

export const postSaih = (saih: Saih): Promise<Saih> => {
  return axios.post<Saih>("/saih/", saih).then(responseHandlerDefault);
};

export const getSaih = (
  page?: number,
  size?: number,
  filter?: Filter
): Promise<Pagination<Saih>> => {
  const params: { page?: number; size?: number; filter?: Filter } = {};
  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }
  if (filter) {
    params.filter = filter;
  }
  return axios.get<Pagination<Saih>>(`/saih/`, { params }).then(responseHandlerDefault);
};
